import { graphql } from "react-relay";

export const PERSONALIZED_NOTIFICATION_TEMPLATE_FRAGMENT = graphql`
	fragment createPersonalizedNotificationTemplateButton_PersonalizedNotificationTemplateFragment on Query
	@refetchable(queryName: "createPersonalizedNotificationTemplateButton_Refetch") {
		Admin {
			Notification {
				GetAvailableNotificationTemplates {
					key
					title
				}
			}
		}
	}
`;

export const CREATE_PERSONALIZED_NOTIFICATION_TEMPLATE_MUTATION = graphql`
	mutation createPersonalizedNotificationTemplateButton_CreateMutation(
		$input: CreatePersonalizedNotificationTemplateInput!
		$connections: [ID!]!
	) {
		Admin {
			Notification {
				createPersonalizedNotificationTemplate(input: $input) {
					edge @appendEdge(connections: $connections) {
						node {
							...personalizedNotificationTemplatesTable_PersonalizedNotificationTemplatesFragment
						}
					}
				}
			}
		}
	}
`;
